import type { components } from '@/generated/internal-api/openapi-types';

export type AuditLogRow = components['schemas']['AuditLogV1.schema'];
export type AuditLogEntityType = components['schemas']['AuditLogEntityType.schema'];
export type AuditLogOperation = components['schemas']['AuditLogOperation.schema'];

export const AUDIT_LOG_ENTITY_TYPES = [
  'ANIMAL',
  'ANIMAL_ALERT',
  'ANIMAL_DEFINITION',
  'CAGE',
  'CAGE_METRIC',
  'DOSAGE',
  'EXPORT',
  'MEASUREMENT',
  'OBSERVATION',
  'SAMPLE',
  'SAMPLE_DEFINITION',
  'STUDY',
  'STUDY_ALERT',
] as const satisfies ReadonlyArray<AuditLogEntityType>;

export const AUDIT_LOG_OPERATIONS = [
  'CREATE',
  'UPDATE',
  'DELETE',
  'VIEW',
] as const satisfies ReadonlyArray<AuditLogOperation>;

export type AuditLogEntitySummary = components['schemas']['AuditLogEntitySummaryV1.schema'];
export type AuditLogEntityHistory = components['schemas']['AuditLogEntityHistoryV1.schema'];
export type AuditLogAnimalSummary = components['schemas']['AuditLogAnimalSummaryV1.schema'];
export type AuditLogSampleSummary = components['schemas']['AuditLogSampleSummaryV1.schema'];
export type AuditLogDosageSummary = components['schemas']['AuditLogDosageSummaryV1.schema'];
export type AuditLogObservationSummary = components['schemas']['AuditLogObservationSummaryV1.schema'];
export type AuditLogMeasurementSummary = components['schemas']['AuditLogMeasurementSummaryV1.schema'];
